import NextLink from 'next/link';
import { tv } from 'tailwind-variants';

import Avatar from 'features/shared/Avatar';

const defaultStyles = tv({
  slots: {
    children: ['italic', 'truncate'],
    link: ['hover:underline'],
    score: ['font-bold'],
    username: ['truncate'],
    wrapper: ['flex', 'gap-3', 'items-center', 'text-sm'],
  },
  variants: {
    theme: {
      dark: {
        children: ['text-neutral-300'],
        link: ['text-white'],
        score: ['text-white'],
        username: ['text-neutral-300'],
      },
      light: {
        children: ['text-neutral-500'],
        link: ['text-neutral-900'],
        score: ['text-blue-500'],
        username: ['text-neutral-500'],
      },
    },
  },
});

const deletedStyles = tv({
  base: ['font-secondary', 'font-semibold', 'whitespace-nowrap'],
});

export default function UserDetails({
  className,
  children,
  theme = 'light',
  user,
  usernameIsHidden,
}) {
  if (!user) {
    return (
      <span className={deletedStyles({ class: className })}>
        Account deleted
      </span>
    );
  }

  const {
    children: childrenStyles,
    link,
    score,
    username,
    wrapper,
  } = defaultStyles({ theme });

  return (
    <div className={wrapper({ class: className })}>
      <Avatar href={`/profile/${user.username}`} user={user} withModal />

      <div className="flex flex-col overflow-hidden">
        <div className="flex font-bold gap-1 items-baseline">
          <NextLink
            aria-label={`Visit ${user.displayName}'s profile`}
            className={link({
              class: 'font-secondary outline-offset-[-3px] truncate',
            })}
            href={`/profile/${user.username}`}
          >
            {user.displayName}
          </NextLink>

          <span className={link()}>•</span>

          <span className={score()}>
            {(user.mentorScore.total ?? user.mentorScore).toLocaleString()}
          </span>
        </div>

        <div className="flex flex-wrap gap-x-2 items-baseline">
          {!usernameIsHidden && (
            <span className={username()}>@{user.username}</span>
          )}

          {children && <span className={childrenStyles()}>{children}</span>}
        </div>
      </div>
    </div>
  );
}
